<template>
    <b-overlay :show="busy" rounded="sm">
      <!-- {{ search }}<br /><br />
      {{ item }} -->
      <b-card class="standardpage reports invoices border-none">
        <div class="availtable datatable text-left">
          <b-card-body class="py-0">
            <b-tabs class="gridtabs">
              <b-tab :active="true">
                <template #title>
                  <div class="badgecontainer pr-5">
                    <i :class="options.icon" class="text-primary mr-1"></i>
                    <span class="text-center badgenormal badge-secondary badge-pill">
                      {{ item.code }}
                    </span>
                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                  </div>
                </template>
                <p class="py-3 px-0">
                  <b-row>                   
  
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Code" label-for="code" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.code" placeholder="Enter code"
                            size="sm"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.code = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
  
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Type" label-for="type" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.type" placeholder="Enter type"
                            size="sm"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.type = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6">
                      <b-form-group label="Description" label-for="description" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.description" placeholder="Enter description"
                            size="sm"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.description = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </p>
              </b-tab>
              <b-tab v-if="idselected">
                <template #title>
                  <i class="fa fa-history text-primary mr-1"></i> Audit
                </template>
                <p class="py-3 px-0">
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Created At" label-for="created_at" label-cols="12">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                              locale="en-GB" :disabled="true"></b-form-datepicker>
                          </b-input-group-prepend>
                          <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                              :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
  
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Created By" label-for="created_by" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                              :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
  
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                              locale="en-GB" :disabled="true"></b-form-datepicker>
                          </b-input-group-prepend>
                          <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                              :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
  
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                              :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </p>
              </b-tab></b-tabs>
  
  
  
          </b-card-body>
          <b-card-footer class="nopadding mt-2">
            <b-row no-gutters>
              <b-col cols="auto" class="text-left mr-3">
                <b-button squared size="sm" variant="primary" @click="saveit"
                  v-if="user.permissions.includes('setup_ordersreasons.admin')">
                  <i class="fa fa-check"></i>
                  Save It
                </b-button>
              </b-col>
              <b-col class="text-left my-auto">
                <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div>
              </b-col>
              <b-col class="text-right" cols="8">
                <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                  <i class="fa fa-chevron-left pr-1"></i>
                  Back
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </div>
      </b-card>
    </b-overlay>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import gql from "graphql-tag";
  
  import moment from "moment";
  
  export default {
    name: "OrdersReasonsEdit",
  
    data() {
      return {
        busy: false,
  
        item: { description: null, code: null, type: null },
        options: {
          title: "OrdersReason",
          icon: "fa fa-gavel",
        },
      };
    },
    methods: {
      async load() {
        let variables = {
          id: this.idselected,
          dateformat: "YYYY-MM-DD",
        };
        console.log("variables", variables);
        try {
          const response = await this.$apollo.query({
            query: gql`
              query setup_ordersreasons($id: String) {
                setup_ordersreasons(id: $id) {
                  id
                  description
                  code
                  type
                  created_at
                  created_by
                  updated_at
                  updated_by
                }
              }
            `,
            variables,
          });
  
          if (response.data.setup_ordersreasons.length > 0) {
            this.item = response.data.setup_ordersreasons[0];
          }
        } catch (error) {
          console.log(error);
        }
        this.busy = false;
      },
      async saveit() {
        this.busy = true;
  
        let variables = { rows: [this.cleanit(this.item)] };
        console.log("variables", variables);
  
        try {
          const response = await this.$apollo.mutate({
            mutation: gql`
              mutation setup_ordersreasons_save(
                $rows: [setup_ordersreasons_input]
                $dateformat: String
              ) {
                setup_ordersreasons_save(rows: $rows, dateformat: $dateformat) {
                  id
                  description
                  code
                  type
                }
              }
            `,
            variables,
          });
          console.log(response);
          this.message = "<span class='text-primary'>Saved it.</span>";
        } catch (error) {
          this.message = "<span class='text-danger'>" + error.message + "</span>";
        }
  
        this.busy = false;
      },
    },
  };
  </script>
  
  <style></style>